import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0381663c"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0381663c&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/fe/mewo-website-vue-hmt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0381663c')) {
      api.createRecord('0381663c', component.options)
    } else {
      api.reload('0381663c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0381663c", function () {
      api.rerender('0381663c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lottery/index.vue"
export default component.exports